import React from 'react';

//Components.
import SignUpForm from '../../form/sign-up-form/SignUpForm';

//Dependencies.
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'

import './SignUpModal.styles.css'


const SignUpModal = ({ modal, setModal }) => {
   const toggle = () => setModal(!modal);

   const closeBtn = (
      <button className='close text-danger' onClick={toggle} type='button' style={{border: 'none', fontWeight: 'bolder'}}>
         <h3>&times;</h3>
      </button>
   )

   return (
      <>
         <Button color='danger' onClick={toggle}>
            CLICK ME!!!
         </Button>
         <Modal isOpen={modal} toggle={toggle} fullscreen>
            <ModalHeader toggle={toggle} close={closeBtn}>
              <span className='text-danger'>SIGN UP AND CREATE YOUR NEW ACCOUNT, <em>NEW USER</em>!!!</span>
            </ModalHeader>
            <ModalBody className='modalBody'>
               <SignUpForm modal={modal} setModal={setModal} />
            </ModalBody>
         </Modal>
      </>
   )
}

export default SignUpModal